import PropTypes from "prop-types";
import clsx from "classnames";
import { Title } from "@/ui";
import classes from "./styles.module.scss";
import { HomeJobSearch } from "@/components";
import { useEffect, useState } from "react";
import Body from "@/ui/Body";

export default function Hero({ className, img, title, title2, video, boldTitle, description }) {
  return (
    <div className={clsx(className, classes.hero)}>
      <div className={classes.video}>
        <video
          autoPlay
          loop
          playsInline
          muted
          alt="All the devices"
          src={video}
          style={{ height: "100%"}}
        />
        <div className={classes.overlay}></div>
      </div>
      <div className={classes.content}>
        <h1>
          <Title title={title} tag="div" />
          <Title title={title2} className={`highlight primary h1 ${classes.title}`} tag="div" />
        </h1>
        <Body body={description} className={classes.subtitle} />
      </div>
    </div>
  );
}

Hero.defaultProps = {
  className: "",
};

Hero.propTypes = {
  className: PropTypes.string,
};
